<template>
  <v-card class="record-card">
    <v-card-text>
      <v-layout row>
        <v-flex grow class="font-weight-black headline">
          {{
            record.isDuration()
              ? displayDuration(record.data.value)
              : monthString(record.data.creationTimestamp) +
                " " +
                dayString(record.data.creationTimestamp)
          }}
        </v-flex>
        <v-flex shrink class="pa-0">
          <v-btn small class="ma-0" flat icon color="red" @click="onDelete">
            <v-icon small>fas fa-trash-alt</v-icon>
          </v-btn></v-flex
        >
        <v-flex
          class="vertical font-weight-light"
          style="position:absolute; right:0px; bottom:8px;"
        >
          {{ year(record.data.creationTimestamp) }}
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex style="margin-bottom:5px;" shrink>
          {{ startToEndString }}
        </v-flex>
        <v-flex v-if="record.isDuration()" shrink>
          {{ monthString(record.data.creationTimestamp) }}
          {{ dayString(record.data.creationTimestamp) }}
        </v-flex>
        <v-flex shrink class="pa-0">
          <!-- Note Button -->
          <v-btn
            v-if="record.hasNote()"
            icon
            small
            :dark="isNoteShowing"
            :color="isNoteShowing ? 'black' : 'white'"
            @click="toggleNote"
          >
            <v-icon small>far fa-sticky-note</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-slide-y-transition>
          <v-flex class="textbox" v-show="isNoteShowing">
            {{ record.data.note }}
          </v-flex>
        </v-slide-y-transition>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { Record } from "@/classes/Record/Record";
import { Time } from "@/lib/Time";
export default {
  props: {
    record: {
      type: Record
    }
  },
  data() {
    return {
      isNoteShowing: false
    };
  },
  computed: {
    startToEndString() {
      let result = this.time(this.record.data.creationTimestamp);
      let end = this.time(this.record.data.endTimestamp);
      if (end !== result) {
        result += ` ~ ${this.time(this.record.data.endTimestamp)}`;
      }
      return result;
    }
  },
  methods: {
    onDelete() {
      this.record.remove();
    },
    toggleNote() {
      this.isNoteShowing = !this.isNoteShowing;
    },
    monthString(timestamp) {
      return Time.date.monthString(timestamp);
    },
    dayString(timestamp) {
      return Time.date.dayString(timestamp);
    },
    displayDuration(duration) {
      let hour = Time.duration.as(duration, Time.unit.hour, true);
      let min = Time.duration.get(duration, Time.unit.minute);
      let sec = Time.duration.get(duration, Time.unit.second);
      return `${hour}:${min}:${sec}`;
    },
    year(timestamp) {
      return Time.date.get(timestamp, Time.unit.year);
    },
    day(timestamp) {
      return Time.date.get(timestamp, Time.unit.day);
    },
    date(timestamp) {
      return `${Time.date.get(timestamp, Time.unit.year)} - ${Time.date.get(
        timestamp,
        Time.unit.month
      )} - ${Time.date.get(timestamp, Time.unit.day)}`;
    },
    time(timestamp) {
      let hours = Time.date.get(timestamp, Time.unit.hour);
      let isPM = hours >= 12;
      let minutes = Time.date.get(timestamp, Time.unit.minute);
      return `${isPM ? hours - 12 : hours}:${minutes} ${isPM ? "PM" : "AM"}`;
    }
  }
};
</script>

<style scoped>
.record-card {
  min-height: 125px !important;
}

.vertical {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-align: right;
}

.textbox {
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  padding-right: 30px !important;
}
</style>
